import { dispatchStorageEvent } from './dispatch-storage-event'

export function removeLocalStorageItem(key: string) {
  localStorage.removeItem(key)
  dispatchStorageEvent(key, null)
}
